import React, { PropsWithChildren } from 'react';
import { BaseProps, RefOrUndefined } from './Types';
import styles from './EditorButton.module.css';

function constructButton(
  {
    active,
    ...props
  }: PropsWithChildren<
    {
      active: boolean;
    } & BaseProps<HTMLSpanElement>
  >,
  ref: RefOrUndefined<HTMLSpanElement>
) {
  return (
    <span
      {...props}
      ref={ref}
      className={active ? styles.EditorButtonActive : styles.EditorButton}
    />
  );
}

export const EditorButton = React.forwardRef(constructButton);
